<template>
  <div>
    <a-select 
      v-model="user_id" 
      allowClear 
      @change="finish_select"
      placeholder="请选择用户" 
      style="width: 150px; margin-left:10px"
      showSearch
      :filterOption="false"
      @search="handleSearch"
      :loading="loading"
    >
      <a-select-option :value="user.value" v-for="user, index in users" :key="index">{{ user.label }}</a-select-option>
    </a-select>
  </div>
</template>

<script>
  export default {
    props: {
    },
    data() {
      return {
        users: [],
        user_id: '',
        loading: false
      }
    },
    created() {
      this.loadUsers();
    },
    methods: {
      async loadUsers(search = '') {
        this.loading = true;
        try {
          // 使用租户用户列表接口，获取当前租户的用户
          const res = await this.$api.getTenantUsersList({ 
            keyword: search,
            page_size: 100 
          });
          const userList = res.data?.list || res.data || [];
          this.users = userList.map((o) => {
            return {
              label: `${o.user_name}${o.mobile ? '-' + o.mobile : ''}`,
              value: o.id,
            };
          });
        } finally {
          this.loading = false;
        }
      },

      handleSearch(value) {
        this.loadUsers(value);
      },

      finish_select() {
        this.$emit('finish_select', this.user_id)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
